<template>
  <div>
    <div class="d-flex justify-content-between">
      <div>
        <div class="section-title">{{ $t("cinemasettings") }}</div>
      </div>
      <div>
        <b-button
          v-if="$can('create', 'Cinema Settings')"
          :disabled="isRoleID"
          variant="default"
          to="add-cinema-settings"
          class="btn-blue"
          >{{ $tc("add") }}</b-button
        >
      </div>
    </div>

    <div class="d-flex justify-content-between align-items-center my-3">
      <div>
        <b-form-input
          v-debounce:300="onSearch"
          v-model="searchValue"
          placeholder="Search..."
        ></b-form-input>
      </div>
      <div class="d-flex align-items-center">
        <label class="mb-0 mr-2" style="white-space: nowrap;">Status:</label>
        <b-form-select
          v-model="statusFilter"
          :options="statusOptions"
          size="sm"
          style="min-width: 130px;"
        ></b-form-select>
      </div>
      <div class="d-flex align-items-center">
        <div class="viewing-status btn-blue">
          {{ $t("viewing") }}
          <span>{{ filteredCinemaSettings.length }}</span
          >{{ $t("of") }}
          <span>{{ cinema_settings.length }}</span>
        </div>
        <button
          class="btnj btn-gridView mr-3"
          :class="gridView ? 'active' : ''"
          v-on:click="viewType('gridView')"
        ></button>
        <button
          class="btnj btn-listView"
          :class="listView ? 'active' : ''"
          v-on:click="viewType('listView')"
        ></button>
      </div>
    </div>

    <!-- GRID VIEW -->
    <div class="desg-grid-container" v-if="gridView">
      <div
        class="col-md-4 col-lg-4 col-xl-3 px-0"
        v-for="(cinema, cinemakey) in filteredCinemaSettings"
        :key="cinemakey"
      >
        <div class="desg-box">
          <div class="d-flex justify-content-between">
            <h6 class="d-flex align-items-center">
              <span
                class="status-dot mr-2"
                :class="cinema.cine_setting_is_active == 'Y' ? 'status-dot--active' : 'status-dot--inactive'"
                v-b-tooltip.hover
                :title="cinema.cine_setting_is_active == 'Y' ? 'Active' : 'Inactive'"
              ></span>
              {{ cinema.cine_name }}
            </h6>
            <div>
              <b-dropdown right variant="edit" class="ml-4">
                <b-dropdown-item
                  v-if="$can('update', 'Cinema Settings')"
                  :disabled="isRoleID"
                  @click="goToRoute('edit-cinema-settings', cinema)"
                >
                  <span class="edit-pen"></span>
                  {{ $t("edit") }}
                </b-dropdown-item>
                <b-dropdown-item
                  @click="goToRoute('view-cinema-settings', cinema)"
                >
                  <span class="icon-eye mr-1"></span>
                  {{ $t("view") }}
                </b-dropdown-item>
              </b-dropdown>
            </div>
          </div>

          <div class="d-flex justify-content-between align-items-end">
            <div class="d-flex align-items-end lh-1">
              <div class="count">{{ cinema.cine_screens }}</div>
              <div class="text">
                No of
                <br />Screens
              </div>
            </div>
            <div class="d-flex align-items-end">
              <label class="ios-switch">
                <input
                  :checked="cinema.cine_setting_is_active == 'Y' ? true : false"
                  type="checkbox"
                  class="ios-checkbox"
                  disabled
                />
                <span class="switch-slider"></span>
              </label>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- LIST VIEW DESIGNATION -->
    <table class="list-view-table" v-if="listView">
      <thead>
        <tr>
          <th>
            <img
              v-if="this.columnName != 'cine_name'"
              @click="onSortValue('cine_name', 'asc')"
              src="@/assets/img/icons/updown.svg"
              class="cursor-pointer"
              width="15px"
              height="20px"
            />
            <img
              v-else-if="isSort && isAscending"
              @click="onSortValue('cine_name', 'asc')"
              src="@/assets/img/icons/asc.svg"
              class="cursor-pointer"
              width="15px"
              height="20px"
            />
            <img
              v-else
              @click="onSortValue('cine_name', 'desc')"
              src="@/assets/img/icons/desc.svg"
              class="cursor-pointer"
              width="15px"
              height="20px"
            />{{ $t("cinemaname") }}
          </th>
          <th>{{ $t("businessStartTime") }}</th>
          <th>{{ $t("businessEndTime") }}</th>
          <th>Status</th>
          <th />
        </tr>
      </thead>
      <tbody v-if="filteredCinemaSettings.length > 0">
        <tr
          v-for="(cinema, cinemaKey) in filteredCinemaSettings"
          :key="cinemaKey"
        >
          <!-- <td>
            <div class="d-flex align-items-center justify-content-start">
              <b-dropdown right variant="edit" class="mr-1">
                <b-dropdown-item
                  v-if="$can('update', 'Cinema Settings')"
                  :disabled="isRoleID"
                  @click="goToRoute('edit-cinema-settings', cinema)"
                >
                  <span class="edit-pen"></span>
                  {{ $t("edit") }}
                </b-dropdown-item>
                <b-dropdown-item
                  @click="goToRoute('view-cinema-settings', cinema)"
                >
                  <span class="icon-eye mr-1"></span>
                  {{ $t("view") }}
                </b-dropdown-item>
              </b-dropdown>

              {{ cinema.cine_name }}
            </div>
          </td> -->
          <td>
            <div class="d-flex align-items-center justify-content-start">
              <i
                v-if="$can('update', 'Cinema Settings') && !isRoleID"
                class="edit-pen icon blue-icon cursor-pointer mr-2"
                @click.prevent.stop="goToRoute('edit-cinema-settings', cinema)"
                v-b-tooltip="'Edit Cinema Settings'"
                tabindex="0"
              ></i>
              <i
                class="icon-eye blue-icon cursor-pointer mr-2"
                @click.prevent.stop="goToRoute('view-cinema-settings', cinema)"
                v-b-tooltip="'View Cinema Settings'"
                tabindex="0"
              ></i>

              {{ cinema.cine_name }}
            </div>
          </td>

          <td>{{ cinema.cine_operation_start_time }}</td>
          <td>{{ cinema.cine_operation_end_time }}</td>
          <td>
            <span
              class="status-dot"
              :class="cinema.cine_setting_is_active == 'Y' ? 'status-dot--active' : 'status-dot--inactive'"
              v-b-tooltip.hover
              :title="cinema.cine_setting_is_active == 'Y' ? 'Active' : 'Inactive'"
            ></span>
          </td>
          <td></td>
        </tr>
      </tbody>
      <tbody v-else>
        <tr>
          <td colspan="5">
            <NoRecords />
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import scheduleService from "@/services/scheduleService";
import NoRecords from "@/components/Partials/NoRecords.vue";

export default {
  components: {
    NoRecords,
  },
  data() {
    return {
      gridView: false,
      listView: true,
      cinema_settings: [],
      isRoleID: true,
      selected_id: "",

      debounce: null,
      searchValue: "",

      //sorting
      isSort: false,
      isAscending: false,
      columnName: "",
      orderBy: "",

      // status filter
      statusFilter: "All",
      statusOptions: [
        { value: "All", text: "All" },
        { value: "Active", text: "Active" },
        { value: "Inactive", text: "Inactive" },
      ],
    };
  },
  computed: {
    filteredCinemaSettings() {
      if (this.statusFilter === "Active") {
        return this.cinema_settings.filter(
          (c) => c.cine_setting_is_active === "Y"
        );
      } else if (this.statusFilter === "Inactive") {
        return this.cinema_settings.filter(
          (c) => c.cine_setting_is_active !== "Y"
        );
      }
      return this.cinema_settings;
    },
  },
  beforeMount() {
    let obj = this.secureStore.get("USINFO").cinema_id;
    this.selected_id = obj;
    this.getAllCinemaSettings(obj);
    let roleid = this.secureStore.get("USINFO").role_id;
    if (true) {
      this.isRoleID = false;
    }
  },
  methods: {
    onSortValue(columnName, orderBy) {
      this.isSort = true;
      this.isAscending = !this.isAscending;
      this.columnName = columnName;
      this.orderBy = orderBy;
      this.getAllCinemaSettings(this.selected_id);
    },
    onSearch: function () {
      this.getAllCinemaSettings(this.selected_id);
    },
    getAllCinemaSettings: function (cine_id) {
      scheduleService
        .GetAllCinemaSettings({
          cine_id: cine_id,
          searchValue: this.searchValue,
          columnName: this.columnName,
          orderBy: this.orderBy,
        })
        .then((response) => {
          const { data } = response;
          if (data && data.status) {
            this.cinema_settings = data.Records;
            // console.log(this.cinema_settings);
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch((err) => {
          this.$toasted.show(err);
        });
    },
    /* eslint-disable */

    viewType: function (viewType) {
      if (viewType == "gridView") {
        this.gridView = true;
        this.listView = false;
      } else if ((viewType = "listView")) {
        this.listView = true;
        this.gridView = false;
      }
    },

    goToRoute: function (path, cinema) {
      console.log("cinema id from list :", cinema);
      this.$router.push({
        path: path,
        query: {
          cinema_id: cinema.cine_id,
          cinema_setting_id: cinema.cine_setting_id,
        },
      });
    },
  },
};
</script>

<style scoped>
.status-dot {
  display: inline-block;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  flex-shrink: 0;
}
.status-dot--active {
  background-color: #28a745;
}
.status-dot--inactive {
  background-color: #dc3545;
}
</style>



// WEBPACK FOOTER //
// src/components/Pages/ExhibitorManagement/CinemaSettingsComponents/cinemaSettings.vue